import request from '../request';

/** 发票类型查询 */
export async function getCustomerInvoice(invoiceType?: string) {
  return request<API.CommonResponse<API.CustomerInvoiceVO>>({
    url: '/api/disp/mall/rest/member/customer/invoice/type/query',
    method: 'POST',
    data: {
      invoiceType,
    },
  });
}

/** 查询或者新增发票信息 */
export async function handleCustomerInvoice(
  params?: API.CustomerInvoiceInsertOrQueryReq,
) {
  return request<API.CommonResponse<API.CustomerInvoiceVO>>({
    url: '/api/disp/mall/rest/member/customer/invoice/insert/or/query',
    method: 'POST',
    data: params || {},
  });
}
